import React, { Component } from 'react';
import Chip from '@material-ui/core/Chip';

class DDItemCard extends Component {
  getStatusIcon = () => {
    const { item, columns, businessContextData } = this.props;
    
    // Get business context for the item
    const itemContext = item.businessContext || (businessContextData && businessContextData[item.id]?.businessContext);
    const hasItemContext = itemContext && itemContext.trim();
    
    // For items with columns, check if all columns are documented too
    if (columns && columns.length > 0) {
      const allColumnsDocumented = columns.every(col => {
        const colContext = col.businessContext || (businessContextData && businessContextData[col.id]?.businessContext);
        return colContext && colContext.trim();
      });
      
      // Fully complete: item + all columns documented
      if (hasItemContext && allColumnsDocumented) {
        return (
          <span className="material-icons status-icon completed">
            check_circle
          </span>
        );
      }
      
      // Partially complete or incomplete
      return (
        <span className="material-icons status-icon incomplete">
          error_outline
        </span>
      );
    }
    
    // For items without columns, just check the item context
    return (
      <span className={`material-icons status-icon ${hasItemContext ? 'completed' : 'incomplete'}`}>
        {hasItemContext ? 'check_circle' : 'error_outline'}
      </span>
    );
  }

  render() {
    const {
      item,
      isSelected,
      onClick,
      columns,
      businessContextData,
      isColumnsExpanded,
      onToggleColumns,
      categoryLabel
    } = this.props;

    const itemName = item.tableName || item.viewName || item.procedureName || item.name;
    const itemContext = item.businessContext || (businessContextData && businessContextData[item.id]);
    
    // Calculate documented columns count
    const documentedColumnsCount = columns ? columns.filter(col => {
      const colContext = col.businessContext || (businessContextData && businessContextData[col.id]?.businessContext);
      return colContext && colContext.trim();
    }).length : 0;

    // Fold the table's own business context into the completion badge (#608): the
    // table counts as one documentable unit alongside its fields, so a table with
    // context but blank fields reads 1/(N+1) and full completion (N+1)/(N+1)
    // lines up with the green status icon, which already requires table context.
    const hasTableContext = ((item.businessContext ||
      (businessContextData && businessContextData[item.id]?.businessContext)) || '').trim();
    const documentedCount = documentedColumnsCount + (hasTableContext ? 1 : 0);
    const completionTotal = (columns ? columns.length : 0) + 1;

    return (
      <div
        className={`schema-item context-card ${isSelected ? 'selected' : ''}`}
        onClick={onClick}
        data-testid="dd-object-card"
        data-object-name={itemName}
      >
        <div className="context-card-header">
          {this.getStatusIcon()}
          <div className="card-info">
            <div className="card-name">{itemName}</div>
            <div className="card-type">{categoryLabel || item.type}</div>
          </div>
        </div>
        
        {columns && columns.length > 0 && (
          <div className="columns-compact">
            <div 
              className="columns-compact-toggle"
              onClick={(e) => {
                e.stopPropagation();
                if (onToggleColumns) onToggleColumns();
              }}
            >
              <span className="material-icons">
                {isColumnsExpanded ? 'expand_more' : 'chevron_right'}
              </span>
              <span>{columns.length} columns</span>
              <span
                className="columns-completion-badge"
                title="Documented items including table-level business context (+1 for the table itself)"
              >
                {documentedCount}/{completionTotal}
              </span>
            </div>
            
            {isColumnsExpanded && (
              <div className="columns-compact-list">
                {columns.slice(0, 5).map((col, index) => {
                  const colContext = col.businessContext || (businessContextData && businessContextData[col.id]);
                  const hasContext = colContext?.businessContext ? colContext.businessContext.trim() : (col.businessContext && col.businessContext.trim());
                  
                  return (
                    <div 
                      key={col.columnId || col.id || index} 
                      className="column-compact-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (onClick) onClick();
                      }}
                    >
                      <span className={`material-icons status-icon ${hasContext ? 'completed' : 'incomplete'}`} style={{ fontSize: '16px' }}>
                        {hasContext ? 'check_circle' : 'error_outline'}
                      </span>
                      <span className="column-compact-name">{col.name}</span>
                      {(col.isPii || col.is_pii || col.pii) && (
                        <Chip label="PII" size="small" className="pii-chip" />
                      )}
                      {(col.isAiEligible || col.is_ai_eligible) && (
                        <Chip label="AI Sensitive" size="small" className="ai-eligible-chip" />
                      )}
                      <span className="column-compact-type">{col.dataType || col.DATA_TYPE}</span>
                    </div>
                  );
                })}
                {columns.length > 5 && (
                  <div className="column-compact-item column-compact-more">
                    +{columns.length - 5} more columns
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default DDItemCard;
